var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgVDodoLogo = function SvgVDodoLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f4e028"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.8 8c.32 2 1.23 3.43 2 3.3s1.2-1.8.91-3.75-1.56-5.49-2.36-5.36-.87 3.88-.55 5.81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.64 6c-1.64 2.24-2.23 4.6-1.31 5.27s3-.59 4.64-2.83 4.39-7.62 3.48-8.3-5.17 3.57-6.81 5.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 8.34a11.89 11.89 0 0 0 -11.9 11.89 3 3 0 0 0 1.14 2.26.36.36 0 0 0 .52 0 .35.35 0 0 0 .09-.26v-.05a10 10 0 0 1 10.09-9.84 10 10 0 0 1 10.06 9.81v.14a.37.37 0 0 0 .6.33 3.11 3.11 0 0 0 1.28-2.39 11.89 11.89 0 0 0 -11.88-11.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.37 20.55c-.61 0-1.11-.39-1.11-1.83s.49-2.59 1.11-2.59 1.1 1.16 1.1 2.59-.47 1.83-1.1 1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.48 20.01-.28-.92 2.08-.64-2.73-1.59.49-.84 4.63 2.72z"
  }))));
};

export { SvgVDodoLogo as ReactComponent };
export default __webpack_public_path__ + "1004b8a76d0c6cc6eb2cb3ffa154091c.svg";